export class SectionItem {

    Id: number;
    Code:string;

    constructor() { }
}